<template>
  <div fluid :class="windowWidth < 960 ? 'fondoMovil' : 'fondoPC'" :style="somePanelOpen ? 'height: 100%' : 'height: 100%;'">
    <v-container fluid>
      <v-row class="mb-n6">
        <v-col v-if="windowWidth < 960" cols="12" md="6" class="d-flex justify-center align-self-start" />
        <v-col :md="windowWidth >= 960 && windowWidth <= 1250 ? '7' : '6'" />
        <v-col cols="12" :md="windowWidth >= 960 && windowWidth <= 1250 ? '5' : '6'">
          <h1 class="fMontserrat">
            {{ t("enhorabuena") }}
          </h1>
          <h2 class="fMontserrat">
            {{ t("texto1") + " " + nombre }}
          </h2>
          <FirstExpansionPanel :panel="panel1" v-if="panel1.datosOT != null" />
          <RecursiveExpansionPanel :panels="panelsToShow" />
          <!-- <v-row v-show="datosOT != null && false" class="map-container rounded-xl my-0 mx-auto" style="height: 250px; max-width: 400px">
            <GoogleMap
              id="map"
              api-key="AIzaSyDJYkHjWWiZR9p-ptf6cI31oRQTaJkIZ4k"
              :center="center"
              :zoom="19"
              style="width: 100%; height: 100%"
              class="rounded-xl">
              <Marker :options="{ position: center, title: 'Test' }" @click="infoWindowOpened = !infoWindowOpened">
                <InfoWindow :position="center" v-model="infoWindowOpened">
                  <p>{{ nombre }}</p>
                </InfoWindow>
              </Marker>
            </GoogleMap>
          </v-row> -->
        </v-col>
      </v-row>
    </v-container>
    <!-- PC -->
    <FooterComponent v-if="windowWidth >= 960" />
    <v-overlay :model-value="overlay" opacity="0.8" class="align-center justify-center text-center">
      <v-progress-circular color="success" indeterminate size="64" />
      <div class="mt-6">{{ t("gettingData") }}...</div>
    </v-overlay>
  </div>
</template>

<script setup>
// http://localhost:8080/order/?x=cIGU0cci6J653EpMjndOmQ==&y=it35dgA8sc9symV+ZnOLrg==&z=TiZNVfXhBSlLYLSU8KbPdA==
import RecursiveExpansionPanel from "../components/RecursiveExpansionPanel.vue";
import FirstExpansionPanel from "../components/FirstExpansionPanel.vue";

import CryptoJS from "crypto-js";
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import axios from "axios";
import FooterComponent from "../components/FooterComponent.vue";
import router from "./../router";
import { t } from "../functions/translation.js";
// import { GoogleMap, Marker, InfoWindow } from "vue3-google-map";

var panels = ref([]);
var panel1 = ref({});
const x = ref("");
const y = ref("");
const claveStr = "ClaveDeIndo_QR$$";
const ivStr = "VECTORDEINDOQR$$";
const codigo = ref("");
const OT = ref("");
const cliente = ref("");
var datosOT = ref(null);
var overlay = ref(false);
var nombre = ref("");
// const infoWindowOpened = ref(false);
// const darkMapStyle = ref([
//       {
//         elementType: 'geometry',
//         stylers: [
//           {
//             color: '#242f3e',
//           },
//         ],
//       },
//       {
//         elementType: 'labels.text.stroke',
//         stylers: [
//           {
//             color: '#242f3e',
//           },
//         ],
//       },
//       {
//         elementType: 'labels.text.fill',
//         stylers: [
//           {
//             color: '#746855',
//           },
//         ],
//       },
//       // Añadir más estilos oscuros según necesites
//     ]);

var windowWidth = ref(window.innerWidth);
// const center = { lat: 41.491531, lng: 2.031798 };
// const themes = ['aubergine', 'dark', 'grey', 'minimal', 'retro', 'roadways', 'roadwaysMinimal', 'ultraLight']
// const theme = ref('dark')
const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

const descifrarAES = (textoCifrado) => {
  const key = CryptoJS.enc.Utf8.parse(claveStr);
  const iv = CryptoJS.enc.Utf8.parse(ivStr);
  const bytes = CryptoJS.AES.decrypt(textoCifrado, key, { iv: iv });

  return bytes.toString(CryptoJS.enc.Utf8);
};

// const cifrarAES = (texto) => {
//   const key = CryptoJS.enc.Utf8.parse(claveStr);
//   const iv = CryptoJS.enc.Utf8.parse(ivStr);
//   const textoCifrado = CryptoJS.AES.encrypt(texto, key, { iv: iv });

//   return textoCifrado.toString();
// };

// const places = ref([]);
// console.log(places)
// const getNearbyPlaces = () => {
//   const opticaPlace = new window.google.maps.LatLng(41.491531, 2.031798);
//   const map = new window.google.maps.Map(document.getElementById("map"), {
//     center: opticaPlace,
//     zoom: 15,
//   });
//   const request = {
//     query: cliente.value,
//     fields: ["name", "geometry"],
//   };

//   var service = new window.google.maps.places.PlacesService(map);

//   service.findPlaceFromQuery(request, (results, status) => {
//     if (status === window.google.maps.places.PlacesServiceStatus.OK && results) {
//       for (let i = 0; i < results.length; i++) {
//         // createMarker(results[i]);
//         console.log(results[i])
//       }

//       map.setCenter(results[0].geometry.location);
//     }
//   });

// const service = new window.google.maps.places.PlacesService(document.createElement("div"));
// service.nearbySearch(
//   {
//     location: center,
//     radius: 500, // Radio en metros
//     type: "Optica", // Tipo de lugar que estás buscando
//   },
//   (results, status) => {
//     if (status === window.google.maps.places.PlacesServiceStatus.OK) {
//       places.value = results;
//       // findClosestPlace()
//     }
//   }
// );
// };

const axiosInstance = axios.create({
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

onMounted(() => {
  const url = window.location.href;
  const searchParams = new URLSearchParams(url.split("?")[1]);
  x.value = (searchParams.get("x") || "").replace(/ /g, "+");
  y.value = (searchParams.get("y") || "").replace(/ /g, "+");
  OT.value = descifrarAES(x.value);
  codigo.value = descifrarAES(y.value);

  if (OT.value == null || OT.value === "") {
    router.push("/");
    return;
  }

  window.addEventListener("resize", handleResize);
  getLensInfo(OT.value);
  getClientUbication(cliente.value);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const getLensInfo = function (ot) {
  overlay.value = true;
  var dto = { OT: ot };
  axiosInstance
    .post(process.env.VUE_APP_INDO_WS + "/ObtenerInfoLente", dto)

    .then((res) => {
      datosOT = ref(res.data);
      nombre.value = datosOT.value.Cliente.Nombre;
      setPanelsValues();
      // getNearbyPlaces();
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      overlay.value = false;
    });
};

const getClientUbication = (client) => {
  var a = 1;
  if (a === 1) return true;
  var dto = {
    codigo_cliente: client,
    read: "1",
  };
  axiosInstance
    .post(process.env.VUE_APP_INDO_API, dto, {
      timeout: 30000,
      headers: { "Content-Type": "application/json; charset=utf-8" },
    })
    .then(() => {
      console.log("Obtener datos Optica:");
    })
    .catch((err) => {
      console.error(err);
    });
};

const getDescriptionTrat = (trat, desc) => {
  switch (trat) {
    case "S0":
      return "Natural Super ClearZero";
    case "CF2":
      return "Natural 10";
    case "B0":
      return "Natural e Blue Zero";
    case "NIIR":
      return "Natural IR";
    case "EBLU":
      return "Natural Blue";
    case "SUV":
      return "Natural Sun UV";
    case "CFR":
      return "Cefir";
    default:
      return desc.replaceAll("Tratamiento", "").trimStart();
  }
};

const getKeyText = (key) => {
  if (key == null) return "";
  return key.toLowerCase().replaceAll(" ", "").replace(",", "").replaceAll("-", "");
};
const getTituloTexto = (valor) => {
  if (valor.startsWith("PV00") || valor.startsWith("PT")) return "Pottencia 0,0 VS";
  if (valor.startsWith("PV11") || valor.startsWith("PV04") || valor.startsWith("PV06") || valor.startsWith("PV08")) return "Pottencia + VS";
  if (valor.startsWith("SKMIO")) return "Superkid Miofocal";
  if (valor.startsWith("LA")) return "Lecta";
  if (valor.startsWith("LO")) return "Work";
  if (valor.startsWith("XU")) return "Unimax";
  if (valor.startsWith("UXS")) return "Unimax Sport";
  if (valor.startsWith("MVV")) return "MaxVita VS";
  if (valor.startsWith("MWV")) return "MaxView VS";
  if (valor.startsWith("MXV")) return "Maxima VS";
  if (valor.startsWith("MXSV")) return "Maxima Sport";
  if (valor.startsWith("ESV")) return "EasyMax VS";
  if (valor.startsWith("2W")) return "2Work";
  if (valor.startsWith("B-EX")) return "Eyemax";
  if (valor.startsWith("ALV")) return "Alura VS";
  if ((valor.startsWith("INV") || valor.startsWith("INU")) && !valor.startsWith("INVIS")) return "Ingenia VS";
  if (valor.startsWith("ACT") || valor.startsWith("ACV")) return "Activa VS";
  if (valor.startsWith("AT") && valor.startsWith("ATM")) return "Adapta";
  return valor;
};

const getDescripcionTipoLente = (valor, isMono, isStock) => {
  var titulo = "";
  if (!isMono) titulo = getTituloTexto(valor);
  else if (isStock) titulo = "MonofocalStock";
  else titulo = "MonofocalLab";
  var res = getKeyText(titulo);
  return res;
};

const setPanelsValues = () => {
  var datos = datosOT.value;
  var isStock = datos.Ruta.startsWith("S");
  var content2 = `<p style="font-weight: bold;">#TituloTipo# </p> #DescripcionTipo#`;
  var descripcion = getDescripcionTipoLente(datos.TipoLente2, datos.Tipo === "Monofocal", datos.Stock === "true");
  // console.log(descripcion);
  // console.log(t(descripcion));
  content2 = t(descripcion) === "" ? "" : content2.replace("#TituloTipo#", datos.TipoLente).replace("#DescripcionTipo#", t(descripcion));
  // console.log(content2);

  var matLente = datos.MaterialLente === "O" ? "Orgánico" : "Mineral";
  
  //Mini chapusa hasta resolver BLS
  if (content2.includes("BLS")){
    datos.TipoMaterial = "BLS";
  }
  var tituloMaterial = `${datos.Material == null ? "" : datos.Material} ${datos.TipoMaterial == null ? "" : datos.TipoMaterial} ${matLente}`; 
  var content3 = isStock ? "" : `<p style="font-weight: bold;">#TituloMaterial#</p> #Material# #TipoMaterial#`;
  content3 = content3
    .replace("#TituloMaterial#", tituloMaterial)
    .replace("#Material#", t(getKeyText(datos.Material)))
    .replace("#TipoMaterial#", t(getKeyText(datos.TipoMaterial)));

  var tratamientos = isStock
    ? getDescriptionTrat(datos.Tratam1, "")
    : datos.Ojos[0].Tratamientos.map((x) => getDescriptionTrat(x.Abreviacion, x.Descripcion)).join("<br>");

  var content4 = tratamientos === "" ? "" : `<p style="font-weight: bold;">#TituloTratamiento#</p> #Tratamiento#`;

  content4 = content4.replace("#TituloTratamiento#", tratamientos).replace("#Tratamiento#", t(getKeyText(tratamientos)));

  var content5 = t(`cuidadoGafas`);
  panel1.value = {
    id: 1,
    title: t(`titulo1Producto`),
    datosOT: datos,
    color: "#088E4B",
    subColor: "#D3D1D3",
    ojoD: "",
    ojoI: "",
    tratamientos: tratamientos,
    materialIndice: tituloMaterial,
    coloracion: "",
  };
  const getImageContent = (descripcion) => {
    if (descripcion === "ingeniavs") return "/images/Ingenia VS.svg";
  };
  panels.value = [
    {
      id: 2,
      title: t(`titulo2Producto`),
      content: content2,
      color: "#088E4B",
      subColor: "#D3D1D3",
      imageContent: getImageContent(descripcion),
    },
    {
      id: 3,
      title: t(`titulo3Producto`),
      content: content3,
      color: "#088E4B",
      subColor: "#D3D1D3",
    },
    {
      id: 4,
      title: t(`titulo4Producto`),
      content: content4,
      color: "#088E4B",
      subColor: "#D3D1D3",
    },
    {
      id: 5,
      title: t(`titulo5Producto`),
      content: content5,
      color: "#088E4B",
      subColor: "#D3D1D3",
    },
  ];
};

var panelsToShow = computed(() => {
  return panels.value.filter((x) => x.content !== "");
});
</script>

<style>
.map-container {
  border-radius: 8px !important;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.movedIcon {
  position: absolute;
  top: 0px;
  left: 0px;
}

.fMontserrat {
  font-family: Montserrat;
}

.rounded-panel {
  border-radius: 20px !important;
}

.rounded-panelText {
  border-radius: 0% 0% 20px 20px;
}
.cursorPointer {
  cursor: pointer;
}

.fondo {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
}
.fondoPC {
  background-image: url("/public/images/Fondo3.png");
  background-repeat: no-repeat;
  background-size: 1400px auto;
  background-color: darkgray;
  background-position: top;
}
.fondoMovil {
  background: radial-gradient(#e1dede, #625f5f8c);
}
.imgShadow {
  filter: drop-shadow(0 0 0.25rem #282424);
}
</style>
